import { IApplicationState } from '../../types/redux';
import { INewbuildingsState } from '../../types/newbuilding/newbuildingsState';

export const getAllNewbuildingIdsSelector = (state: IApplicationState): INewbuildingsState['allIds'] => {
  return state.newbuildings.allIds;
};
